import keymirror from 'keymirror';
import { request } from 'js/api/axios';

import { spreadApiKeys, extractApiKeys } from '../utils';
import { callApi } from '../api';
import { SCHEMAS } from '../api/schemas';

export const types = keymirror({
  ...spreadApiKeys('LIST_CONNECTORS'),
  ...spreadApiKeys('FETCH_CONNECTOR'),
  ...spreadApiKeys('CREATE_CONNECTOR'),
  ...spreadApiKeys('UPDATE_CONNECTOR'),
  ...spreadApiKeys('DELETE_CONNECTOR'),
  ...spreadApiKeys('TEST_CONNECTOR'),
  ...spreadApiKeys('TEST_CONNECTOR_CREDENTIALS'),
});

export function listConnectors(workspaceId, queryId = null) {
  return (dispatch) => {
    return callApi(
      {
        types: extractApiKeys(types.LIST_CONNECTORS, types),
        request: (_data, token) =>
          request.get(`/api/workspaces/${workspaceId}/connectors`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }),
        schema: SCHEMAS.CONNECTOR_ARRAY,
        meta: { queryId },
      },
      dispatch
    );
  };
}

export function fetchConnector(workspaceId, connectorId) {
  return (dispatch) => {
    return callApi(
      {
        types: extractApiKeys(types.FETCH_CONNECTOR, types),
        request: (_data, token) =>
          request.get(
            `/api/workspaces/${workspaceId}/connectors/${connectorId}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          ),
        schema: SCHEMAS.CONNECTOR,
      },
      dispatch
    );
  };
}

export function createConnector(workspaceId, connectorData) {
  return (dispatch) => {
    return callApi(
      {
        types: extractApiKeys(types.CREATE_CONNECTOR, types),
        request: (data, token) =>
          request.post(`/api/workspaces/${workspaceId}/connectors`, data, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }),
        data: { connector: connectorData },
        schema: SCHEMAS.CONNECTOR,
      },
      dispatch
    );
  };
}

export function updateConnector(workspaceId, connectorId, connectorData) {
  return (dispatch) => {
    return callApi(
      {
        types: extractApiKeys(types.UPDATE_CONNECTOR, types),
        request: (data, token) =>
          request.patch(
            `/api/workspaces/${workspaceId}/connectors/${connectorId}`,
            data,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          ),
        data: { connector: connectorData },
        schema: SCHEMAS.CONNECTOR,
      },
      dispatch
    );
  };
}

export function deleteConnector(workspaceId, connectorId) {
  return (dispatch) => {
    return callApi(
      {
        types: extractApiKeys(types.DELETE_CONNECTOR, types),
        request: (_data, token) =>
          request.delete(
            `/api/workspaces/${workspaceId}/connectors/${connectorId}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          ),
      },
      dispatch
    );
  };
}

export function testConnector(workspaceId, connectorId) {
  return (dispatch) => {
    return callApi(
      {
        types: extractApiKeys(types.TEST_CONNECTOR, types),
        request: (_data, token) =>
          request.post(
            `/api/workspaces/${workspaceId}/connectors/${connectorId}/test-connection`,
            {},
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          ),
      },
      dispatch
    );
  };
}

/**
 * Test connector credentials. When connectorId is provided (edit mode), the server
 * merges the form payload with the stored connector and uses stored credentials
 * if the form did not supply a token.
 */
export function testConnectorCredentials(
  workspaceId,
  connectorData,
  connectorId = null
) {
  return (dispatch) => {
    const body = { workspace_id: workspaceId, connector: connectorData };
    if (connectorId) body.connector_id = connectorId;

    return callApi(
      {
        types: extractApiKeys(types.TEST_CONNECTOR_CREDENTIALS, types),
        request: (_data, token) =>
          request.post(
            `/api/workspaces/${workspaceId}/connectors/test-credentials`,
            body,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          ),
      },
      dispatch
    );
  };
}
